
(function () {
  'use strict';
  if (window.DaLucaReadyMasterV367) return;
  window.DaLucaReadyMasterV367 = true;

  function centerThumbs() {
    document.querySelectorAll('.template-product .daluca-pdp #Product-Thumbnails, .template-product .daluca-pdp .product-thumbnail-container').forEach(function (rail) {
      if (rail.closest('.daluca-pdp--apple-standard')) return;
      rail.style.setProperty('display','flex','important');
      rail.style.setProperty('flex-flow','row wrap','important');
      rail.style.setProperty('overflow-x','visible','important');
      rail.style.setProperty('overflow-y','visible','important');
      rail.style.setProperty('justify-content','center','important');
      rail.style.setProperty('align-items','center','important');
      rail.style.setProperty('width','100%','important');
      rail.style.setProperty('max-width','100%','important');
      rail.style.setProperty('margin-left','auto','important');
      rail.style.setProperty('margin-right','auto','important');
      rail.style.setProperty('transform','none','important');
    });
  }

  function cleanReadyMaster(root) {
    if (!root || !root.classList.contains('daluca-pdp--ready-master')) return;

    var setup = root.querySelector('.daluca-ready-step--setup');
    if (!setup) return;

    // V3.67 has one authoritative add-on component. Remove only retired
    // dynamic fragments; never move the master into its own body.
    setup.querySelectorAll('.daluca-ready-spring-bars, .daluca-ready-vintage-spring-row, .daluca-ready-config-grid, .daluca-ready-quick-return-warning, .daluca-ooak-addon-shell-v365, .daluca-ooak-addon-shell-v364').forEach(function (node) {
      if (!node.closest('.daluca-master-addons-v366')) node.remove();
    });

    var master = setup.matches('.daluca-master-addons-v366') ? setup : setup.querySelector('.daluca-master-addons-v366');
    if (master) {
      master.classList.add('daluca-ready-step--master-addons');
      master.querySelectorAll('.daluca-master-addon-card-v366__media img').forEach(function (img) {
        img.style.setProperty('display','block','important');
        img.style.setProperty('opacity','1','important');
        img.style.setProperty('visibility','visible','important');
      });
    }
  }

  function run() {
    centerThumbs();
    document.querySelectorAll('.daluca-pdp--ready-master').forEach(cleanReadyMaster);
  }

  var timer=0;
  function queue(){ clearTimeout(timer); timer=setTimeout(run,50); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',run,{once:true});
  } else {
    run();
  }

  if (document.body) new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',queue);
  [120,350,700,1200,2200].forEach(function(ms){ setTimeout(run,ms); });
})();


(function () {
  'use strict';
  if (window.DaLucaSpecLeaderGap20261014) return;
  window.DaLucaSpecLeaderGap20261014 = true;

  var scheduled = false;
  var observed = new WeakSet();
  var observedRoots = new WeakSet();
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(queue) : null;
  var rowSelector = '.daluca-ready-specs-row > dt, .daluca-custom-master-specs > dl > div > dt, .daluca-apple-side-details__specs > dl > div > dt, .daluca-accessory-side-details__specs > dl > div > dt, dl.daluca-concierge-story__specs > dt';

  function queue() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; update(); });
  }

  function update() {
    document.querySelectorAll('html#daluca-cream body.template-product .product-section .daluca-pdp').forEach(function (root) {
      root.querySelectorAll(rowSelector).forEach(function (dt) {
        dt.classList.remove('daluca-spec-leader-gap--extended');
        var dd = dt.nextElementSibling;
        while (dd && dd.tagName !== 'DD' && dd.tagName !== 'DT') dd = dd.nextElementSibling;
        if (!dd || dd.tagName !== 'DD') return;
        if (resizeObserver && !observed.has(dd)) {
          resizeObserver.observe(dd);
          observed.add(dd);
        }
        if (!dt.getClientRects().length || !dd.getClientRects().length || getComputedStyle(dt).display !== 'flex') return;
        var walker = document.createTreeWalker(dd, NodeFilter.SHOW_TEXT);
        var rects = [];
        var text;
        while ((text = walker.nextNode())) {
          if (!text.textContent.trim()) continue;
          var parent = text.parentElement;
          if (!parent || getComputedStyle(parent).visibility === 'hidden' || getComputedStyle(parent).visibility === 'collapse') continue;
          var range = document.createRange();
          range.selectNodeContents(text);
          Array.prototype.forEach.call(range.getClientRects(), function (rect) {
            if (rect.width > 0 && rect.height > 0) rects.push(rect);
          });
        }
        if (!rects.length) {
          dt.style.removeProperty('--daluca-spec-leader-base');
          dt.style.removeProperty('--daluca-spec-leader-extension');
          return;
        }
        var top = Math.min.apply(null, rects.map(function (rect) { return rect.top; }));
        var firstLine = rects.filter(function (rect) { return Math.abs(rect.top - top) < 2; });
        var bounds = dd.getBoundingClientRect();
        var rtl = getComputedStyle(dt).direction === 'rtl';
        var blank = rtl ? bounds.right - Math.max.apply(null, firstLine.map(function (rect) { return rect.right; })) : Math.min.apply(null, firstLine.map(function (rect) { return rect.left; })) - bounds.left;
        var extension = Math.min(bounds.width, Math.max(0, blank));
        if (extension > 0.5) {
          dt.style.setProperty('--daluca-spec-leader-base', getComputedStyle(dt, '::after').width);
          dt.style.setProperty('--daluca-spec-leader-extension', extension.toFixed(2) + 'px');
          dt.classList.add('daluca-spec-leader-gap--extended');
        } else {
          dt.style.removeProperty('--daluca-spec-leader-base');
          dt.style.removeProperty('--daluca-spec-leader-extension');
        }
      });
    });
  }

  function start() {
    document.querySelectorAll('.product-section .daluca-pdp').forEach(function (root) {
      if (observedRoots.has(root)) return;
      new MutationObserver(queue).observe(root, { childList: true, subtree: true, characterData: true });
      observedRoots.add(root);
    });
    queue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('pageshow', queue);
  document.addEventListener('shopify:section:load', start);
  if (document.fonts) {
    document.fonts.ready.then(queue);
    document.fonts.addEventListener('loadingdone', queue);
  }
})();
